import * as React from 'react';
import * as moment from 'moment';
import { CartItemsProps, CartItemGroupViewProps } from '../../components/cart/cart-items';
import CartItem from '../../components/cart/cart-item';
import { filterMap } from '../../helpers/map-helpers';
import CartMessages from '../../components/cart/cart-messages';

const CartItemGroupView: React.StatelessComponent<CartItemGroupViewProps> = props => {
    const anyPerformances = Array.from(props.cartItems.keys()).length > 0;
    return (
        anyPerformances &&
        <div className="stack-sm">
            {
                props.groupName.length > 0 ?
                    <>
                        <div className="stack-xs">
                            <p className="bold" data-demo-label="Performance Group Description">{props.groupName}</p>
                            <CartMessages performanceGroupId={props.groupId} />
                        </div>
                    </>
                    : null
            }

            <ul className={`stack stack-border ${props.groupName.length > 0 ? 'space-top-sm border-top' : ''}`}>
                {
                    Array.from(props.cartItems.keys()).map(item =>
                        <CartItem key={item} itemId={item} selectedZoneId={props.cartItems.get(item)} />
                    )
                }
            </ul>
        </div>
    )
}

const CartItemsView: React.StatelessComponent<CartItemsProps> = props => {

    return (
        <>
            {
                props.requiresPerformanceGroups ?
                    props.performanceGroups.map(pg => {
                        const groupPerfIds = pg.tessPerformances.map(p => p.performanceId);
                        const groupPerformances = filterMap(props.cartItems, p => groupPerfIds.indexOf(p) >= 0);
                        return <CartItemGroupView isFixedPackage={props.isFixedPackage} key={pg.id} text={props.text}
                            cartItems={groupPerformances} performanceMin={pg.minimumPerformances}
                            groupName={pg.description} groupId={pg.id} />
                    })
                    :
                    <CartItemGroupView isFixedPackage={props.isFixedPackage}
                        text={props.text} performanceMin={props.packageMin}
                        groupId={null} groupName="" cartItems={props.cartItems} />

            }

        </>
    );
}

export default CartItemsView;